// @flow

import React from 'react';
import {gt} from 'app/utils/i18n';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {StyledListDiv} from 'app/general/bootstrap/utils';

type Props = {
  processHTMLURL: string,
  canChange: boolean,
};

const EmptyProcessList = ({processHTMLURL, canChange}: Props) => {
  return (
    <StyledListDiv>
      <NoResultsMessage
        head={gt("There aren't any procedures in this process yet")}
      >
        {canChange ? (
          <FullHTMLLink
            className="btn btn-primary"
            html_url={`${processHTMLURL}edit/`}
          >
            <span className="d-none d-inline"> {gt('Add new Procedure')}</span>
          </FullHTMLLink>
        ) : null}
      </NoResultsMessage>
    </StyledListDiv>
  );
};

EmptyProcessList.displayName = 'EmptyProcessList';

export default EmptyProcessList;
